import { GET_USER, RESET_USERS } from "../actions";

const users = (state = [], action) => {
  switch (action.type) {
    case GET_USER:
      if (
        state.some(
          (user) =>
            user.id === action.user.id &&
            user.redmineurl === action.user.redmineurl
        )
      ) {
        return state;
      } else {
        return [...state, action.user];
      }
    case RESET_USERS:
      return [];
    default:
      return state;
  }
};

export default users;
